"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractInfo = contractInfo;
exports.default = exports.TESTNET_ID = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _tokens = _interopRequireDefault(require("./tokens"));

var _contracts = _interopRequireDefault(require("./contracts"));

var abis = _interopRequireWildcard(require("./abis"));

var _kovan = _interopRequireDefault(require("./addresses/kovan.json"));

var _mainnet = _interopRequireDefault(require("./addresses/mainnet.json"));

function contractInfo(network) {
  var _ref;

  var addresses;

  switch (network) {
    case 'mainnet':
      addresses = _mainnet.default;
      break;

    case 'kovan':
      addresses = _kovan.default;
      break;

    case 'test':
      // we "require just in time" here because a non-developer user will not
      // have a testnet addresses file
      addresses = require('./addresses/testnet.json');
      break;
  }

  return _ref = {}, (0, _defineProperty2.default)(_ref, _tokens.default.DAI, [{
    version: 1,
    address: addresses.SAI,
    abi: abis.general.erc20,
    decimals: 18
  }]), (0, _defineProperty2.default)(_ref, _tokens.default.WETH, [{
    version: 1,
    address: addresses.GEM,
    abi: abis.dappHub.dsEthToken,
    decimals: 18
  }]), (0, _defineProperty2.default)(_ref, _tokens.default.PETH, [{
    version: 1,
    address: addresses.SKR,
    abi: abis.general.erc20,
    decimals: 18
  }]), (0, _defineProperty2.default)(_ref, _tokens.default.MKR, [{
    version: 1,
    address: addresses.GOV_OLD || '0x0000000000000000000000000000000000000001',
    abi: abis.general.erc20,
    decimals: 18
  }, {
    version: 2,
    address: addresses.GOV,
    abi: abis.general.erc20,
    decimals: 18
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_TOP, [{
    version: 1,
    address: addresses.TOP,
    abi: abis.daiV1.saiTop
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_PIP, [{
    version: 1,
    address: addresses.PIP,
    abi: abis.dappHub.dsValue
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_PEP, [{
    version: 1,
    address: addresses.PEP,
    abi: abis.dappHub.dsValue
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_PIT, [{
    version: 1,
    address: addresses.PIT,
    abi: abis.daiV1.pit
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_SIN, [{
    version: 1,
    address: addresses.SIN,
    abi: abis.general.erc20
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_DAD, [{
    version: 1,
    address: addresses.DAD,
    abi: abis.dappHub.dsGuard
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_MOM, [{
    version: 1,
    address: addresses.MOM,
    abi: abis.daiV1.mom
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_VOX, [{
    version: 1,
    address: addresses.VOX,
    abi: abis.daiV1.vox
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_TAP, [{
    version: 1,
    address: addresses.TAP,
    abi: abis.daiV1.tap
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_TUB, [{
    version: 1,
    address: addresses.TUB,
    abi: abis.daiV1.tub
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.MAKER_OTC, [{
    version: 1,
    address: addresses.MAKER_OTC,
    abi: abis.exchangesV1.makerOtc
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.SAI_PROXY, [{
    version: 1,
    address: addresses.SAI_PROXY,
    abi: abis.proxies.saiProxy
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.OASIS_PROXY, [{
    version: 1,
    address: addresses.OASIS_PROXY,
    abi: abis.proxies.oasisProxy
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.DS_PROXY_FACTORY, [{
    version: 1,
    address: addresses.DS_PROXY_FACTORY,
    abi: abis.proxies.dsProxyFactory
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.DS_PROXY, [{
    version: 1,
    abi: abis.dappHub.dsProxy
  }]), (0, _defineProperty2.default)(_ref, _contracts.default.PROXY_REGISTRY, [{
    version: 1,
    address: addresses.PROXY_REGISTRY,
    abi: abis.proxies.proxyRegistry
  }]), _ref;
}

var TESTNET_ID = 999;
exports.TESTNET_ID = TESTNET_ID;
var _default = [{
  name: 'mainnet',
  networkId: 1,
  contracts: contractInfo('mainnet')
}, {
  name: 'morden',
  networkId: 2,
  contracts: null
}, {
  name: 'ropsten',
  networkId: 3,
  contracts: null
}, {
  name: 'rinkeby',
  networkId: 4,
  contracts: null
}, {
  name: 'kovan',
  networkId: 42,
  contracts: contractInfo('kovan')
}, {
  name: 'test',
  networkId: 1337,
  contracts: contractInfo('test')
}, {
  name: 'test',
  networkId: TESTNET_ID,
  contracts: contractInfo('test')
}];
exports.default = _default;